import React from "react";

export default function StatCard({ title, value, icon: Icon, iconBg, onClick }) {
  const Wrapper = onClick ? "button" : "div";

  return (
    <Wrapper
      type={onClick ? "button" : undefined}
      onClick={onClick}
      className={`bg-white border rounded-lg shadow-sm p-4 relative hover:shadow-md transition ${
        onClick ? "cursor-pointer text-left w-full" : ""
      }`}
    >
      {/* Icon */}
      <div
        className={`absolute top-4 right-4 w-8 h-8 flex items-center justify-center rounded-md ${iconBg}`}
      >
        <Icon className="text-white text-sm" />
      </div>

      {/* Content */}
      <p className="text-sm text-gray-500 mb-2">{title}</p>
      <h2 className="text-xl font-semibold text-gray-800">{value}</h2>
    </Wrapper>
  );
}
